export const investorCrmGettingStartedArticle = {
  title: 'Investor CRM: Getting Started',
  slug: 'investor-crm-getting-started',
  content: `Investor CRM: Getting Started

Track fundraising outreach, investor stages, and follow-up activity.

1) Open Investor CRM
- Go to /investor-crm.
- The hub uses Pipeline and Investors tabs.

2) Choose an organization
- If no organization is selected, create or pick one.

3) Navigate tabs
- Pipeline: drag-and-drop stages.
- Investors: manage investor records.

Tips
- Use Cmd/Ctrl + K to open the command palette.
`,
};
